import { colorPalette } from '@rakutenfrance/mui';
export const tabs = () => ({
    borderBottom: `0.5px solid ${colorPalette.gray200}`,
    marginBottom: '12px',
    whiteSpace: 'unset',
    width: '100%',
});
export const activeTab = () => ({
    fontWeight: 'bold',
});
export const nonActive = () => ({
    fontWeight: 'normal',
});
export const tabsContainer = () => ({
    flexGrow: 1,
    maxWidth: '500px !important',
});
export const boxLogo = () => ({
    minHeight: '32px',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
});
